import type { ReactNode } from 'react'

const paths: Record<string, ReactNode> = {
  b2b: <><path d="M4 6.5h16v11H4z"/><path d="M8 6.5V4h8v2.5M8 11h8M8 14h5"/></>,
  brands: <><path d="M12 3.5 20 8v8l-8 4.5L4 16V8z"/><path d="m4 8 8 4.5L20 8M12 12.5v8"/></>,
  overview: <><path d="M4 13h6V4H4zM14 20h6v-9h-6zM4 20h6v-3H4zM14 7h6V4h-6z"/></>,
  factories: <><path d="M4 20V8l6 3V7l6 3V4h4v16z"/><path d="M8 15h2M14 15h2M8 18h2M14 18h2"/></>,
  skus: <><path d="m4 7 8-4 8 4-8 4z"/><path d="m4 12 8 4 8-4M4 17l8 4 8-4"/></>,
  shopify: <><path d="M5 8h14l-1 12H6z"/><path d="M9 9V7a3 3 0 0 1 6 0v2"/></>,
  cooperation: <><path d="M7 4h10v16H7z"/><path d="M9.5 8h5M9.5 12h5M9.5 16H13"/></>,
  traffic: <><path d="M4 19V5M4 19h16"/><path d="m7 15 4-4 3 2 5-6"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1a8 8 0 0 0-1.7-1L14.5 3h-5l-.3 3.1a8 8 0 0 0-1.7 1l-2.4-1-2 3.4 2 1.5a7 7 0 0 0 0 2l-2 1.5 2 3.4 2.4-1a8 8 0 0 0 1.7 1l.3 3.1h5l.3-3.1a8 8 0 0 0 1.7-1l2.4 1 2-3.4-2-1.5a7 7 0 0 0 .1-1Z"/></>,
}

export function WorkspaceIcon({name}:{name:string}) {
  return <svg className="workspace-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name] || paths.overview}</svg>
}
